import PhoneNumberRoutes from "@forwardflow/router/PhoneNumberRoutes";

const PhoneNumberLayout = () => {
  return (
    <>
      <PhoneNumberRoutes />
    </>
  );
};

export default PhoneNumberLayout;
